'use strict';

var util = require('../util'),
	dialog = require('../dialog'),
	linchpin = require('int_googletagmanager/linchpin/storelocator');

function loadMoreStores () {
	$('div.store-information').slice(0, 10).show();
	if ($('div.store-information').length <= 10) {
		$('#loadMoreStores').css('display', 'none');
	}
	$('#loadMoreStores').click(function (e) {
		e.preventDefault();
		$('div.store-information:hidden').slice(0, 10).show();
		if ($('div.store-information:hidden').length === 0) {
			$('#loadMoreStores').css('display', 'none');
		}
	});
}

function filterCollection (e) {
	var filterParams = {};
	var filterArray = {};
	// Add class on filters container to show/hide "Clear All Filters" button
	if ($('#secondary .dropper input:checked').length > 0) {
		$('#secondary').addClass('has-filters');
	} else {
		$('#secondary').removeClass('has-filters');
	}
	// prepare filters parameter - take only checked filters
	$('#secondary #location-type input').each(function () {
		if ($(this).prop('checked') === true) {
			filterArray[$(this).prop('id')] = $(this).prop('id');
		}
	});
	if ($.isEmptyObject(filterArray) === false) {
		filterParams.location = filterArray;
	}
	filterArray = {};
	$('#secondary #feature-type input').each(function () {
		if ($(this).prop('checked') === true) {
			filterArray[$(this).prop('id')] = $(this).prop('id');
		}
	});

	if ($.isEmptyObject(filterArray) === false) {
		filterParams.feature = filterArray;
	}
	// append parameters
	var jsonFilters = JSON.stringify(filterParams);
	var tabLink = $('.tabButtons .active .tabLink').attr('href');
	var url = util.appendParamToURL(Urls.getFilteredStores, 'actionType', $('input[name="actionType"]').val());
		url = util.appendParamToURL(url, 'tab', typeof tabLink !== 'undefined' ? tabLink.replace(/^#/, '') : '');
		url = util.appendParamToURL(url, 'filters', jsonFilters);
		url = util.appendParamToURL(url, 'format', 'ajax');
	var options = {
		url: url,
		type: 'POST'
	};
	// Make a ajax call to filter collection of stores
	$.ajax(options).done(function (data) {
		// Update the page with filtered collection of stores
		$('#primary').html(data);
		loadMoreStores();
		window.initHCMap();

		// add generic toggle functionality
		$('.store-name').on('click', function (e) {
			$(this).toggleClass('on').next('.toggleContent').toggleClass('show');
			e.preventDefault();
		});

		$('.customTabs .tabButtons li a').on('click', function (e) {
			e.preventDefault();
			if (!$(this).hasClass('active')) {
				//clear all
				$('.customTabs .tabButtons li').removeClass('active');
				$(this).parent().addClass('active'); //set
				$('.customTabs .cTabs').hide().removeClass('active');
				$('.customTabs .cTabs' + $(this).attr('href')).show().addClass('active'); //the ID is stored as this.href
			}
			window.initHCMap();
		});
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			if (e.currentTarget.id !== 'clearStoreFilters') {
				linchpin.trackFilterEvent(e, 'featureFilters');
			} else {
				linchpin.trackFilterEvent(e, 'clearFilters');
			}
		}
	});
}
function preferredStoreInfoPopup () {
	var dlg, //placeholder for dialog content
	dialogOptions = {
		title: window.Resources.SETTING_PREFERRED_LOCATION,
		dialogClass:'preferred-store-info',
		open: function () {
			$('.preferred-store-info button').click(function () {
						dialog.close();
				});
			}
		},
	url = util.appendParamToURL(window.Urls.pageInclude, 'cid', 'StoreLocator_PreferredLocation_PopUp');
	$.get(url, function (data) {
		dlg = '<div><div class="content">' + data + '</div><button class="close">' + window.Resources.GOT_IT + '</button></div>';
		dialog.open({html: dlg, options: dialogOptions});
	});
}

module.exports = {

	init: function () {
		if (util.isMobile()) {
			var map = document.querySelector('.store_detailed_map');
			var getDirBtn = document.querySelector('.get-dir-store-detail');
			if (map) {
				getDirBtn.before(map);
			}
		}

		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.storeViewEvent();
		}

		$('select[name$="_country"]').on('change', function () {
			var $form = $(this).closest('form');
			$form.submit();
		});
		$('input[name$="_postalCode"]').autocomplete({
			source: util.appendParamToURL(Urls.findPostalCodes, 'country', $('select[name$="_country"]').val()),
			minLength: 2,
			appendTo: '#stores-autocomplete',
			select: function (event, ui) {
				window.location.href = ui.item.url;
			}
		});
		//uncheck all filters
		$('#clearStoreFilters').on('click', function (e) {
			$('#secondary input:checked').prop('checked', false); //uncheck all the filter checkboxes
			$('#secondary .checker span').removeClass('checked');
			$('li').removeClass('checked');
			filterCollection(e);
		});
		// click event handler to all the filter checkboxes
		$('#secondary input').on('click', function (e) {
			filterCollection(e);
		});
		// click event handler for set preferred store button
		$('#set-preferred-store').on('click', function () {
			var url = util.appendParamToURL(Urls.setPreferredStore, 'storeID', $('input[name="storeID"]').val());
			url = util.appendParamToURL(url, 'format', 'ajax');
			var options = {
					url: url,
					type: 'POST'
				};
				// Make a ajax call to set preferred store
				$.ajax(options).done(function (data) {
					$('#preferred-store-container').html(data);
				});
		});
		//create info pop message
		$('#preferred-store-container').on('touchstart, click', '.icon', preferredStoreInfoPopup);

		$('.toggle-working-hours').click(function () {
			$(this).parent().toggleClass('secondary');
		});

		this.initInfoSectionCarousel();

		//update custom select on window resize
		$(window).smartresize(function () {$('select.country').uniform();});

		//show work hour button on store details only
		$('.store-locator-details .toggle-working-hours').show();

		$('.customTabs a[href$="#listTab"]').trigger('click');

		$('.clicker').on('click', function () {
			$(this).parent().toggleClass('opened');
			$(this).parent().find('.dropped').slideToggle();
		});
		$('.dropper input:checkbox').on('change', function () {
			$(this).parents('li').toggleClass('checked');
		});
		$('.customTabs .tabButtons li a').on('click', function (e) {
			e.preventDefault();
			if (!$(this).hasClass('active')) {
				//clear all
				$('.customTabs .tabButtons li').removeClass('active');
				$(this).parent().addClass('active'); //set
				$('.customTabs .cTabs').hide();
				$('.customTabs .cTabs' + $(this).attr('href')).show(); //the ID is stored as this.href
			}
		});
	},
	initInfoSectionCarousel: function () {
		$('#store-info-section-carousel').slick(util.sliderConfigs({instandard:5, inlarge:4, inmedium:4}));
		this.carouselResponsiveStyle();
		$(window).smartresize(this.carouselResponsiveStyle);
	},
	carouselResponsiveStyle: function () {
		var arrows = $('#store-info-section-carousel').find('.slick-next, .slick-prev'),
			contentTile = $('.store-info-section-content'),
			height = $('.store-info-section-image:first').height();

		if (arrows.length) {
			arrows.css('height', height + 'px');
		}

		contentTile.css('height', 'auto');
		contentTile.syncHeight();
	}
};
loadMoreStores();
